import React from 'react';
import './Footer.scss';

interface FooterProps {
  showContact: () => void
}

function Footer(props :FooterProps) {
  return <footer>
          <p>Copyright © 2024. Made with ♥ by Anthony Garvan.</p>
          <p><a href="/privacy.txt">Privacy</a> | <a href="/terms.txt">Terms</a> | <a onClick={props.showContact}>Contact</a></p>
        </footer>
}

export default Footer;
